export default __webpack_public_path__ + "static/media/966.b6aa7157.jpg";